import { format } from 'date-fns';

import { type AiUsagePeriod, DEFAULT_AI_USAGE_PERIOD } from './aiUsagePeriod';

export const AI_USAGE_PLAN_LABELS: Record<string, string> = {
  free: 'Free',
  trialing: 'Trialing',
  flexible: 'Starter',
  premium: 'Premium',
  launch: 'Launch',
  scale: 'Scale',
  unlimited: 'Unlimited',
};

export const AI_USAGE_SURFACE_LABELS: Record<string, string> = {
  create: 'Create',
  edit: 'Edit',
  ask: 'Ask',
};

export const AI_USAGE_STATUS_LABELS: Record<string, string> = {
  running: 'Running',
  done: 'Done',
  error: 'Error',
  stopped: 'Stopped',
};

export const AI_USAGE_STATUS_BADGE_VARIANTS = {
  running: 'info',
  done: 'success',
  error: 'destructive',
  stopped: 'outline',
} as const;

export const formatTurnTime = (createdAt: string) =>
  format(new Date(createdAt), 'd MMM yyyy, HH:mm');

export const aiUsagePageHref = (pageId: string) => `/pages/${pageId}/customize`;

export const aiUsagePageTurnsHref = (sellerId: string, pageId: string) =>
  `/admin/ai-usage/stores/${sellerId}?pageId=${pageId}`;

export const aiUsageStoreHref = (sellerId: string, period?: AiUsagePeriod) =>
  period && period !== DEFAULT_AI_USAGE_PERIOD
    ? `/admin/ai-usage/stores/${sellerId}?period=${period}`
    : `/admin/ai-usage/stores/${sellerId}`;
